<template>
   <div class="contenedor_modal_completo">
      <div class="contenedor_modal_completo_cabecera">
         <button type="button" class="btn btn-sm btn-outline-dark" v-shortkey="['esc']" @shortkey="cerrar"
            @click="cerrar">
            Cerrar
         </button>
      </div>
      <div class="contenedor_modal_completo_contenido">
         <b-container>
            <b-row>
               <div class="col-sm-12 mt-3">
                  <b-tabs content-class="mt-3" fill>

                     <b-tab title="Facturas" active @click="set_modulo('facturas')"></b-tab>

                     <b-tab title="Recibos" @click="set_modulo('recibos')"></b-tab>

                  </b-tabs>
               </div>
            </b-row>

            <Facturas v-if="modulo == 'facturas'" />
            <Recibos v-if="modulo == 'recibos'" />

         </b-container>
      </div>
   </div>
</template>

<script>
   import Facturas from "./Facturas.vue"
   import Recibos from "./Recibos.vue";

   export default {
      name: "ReImpresion",
      components: {
         Facturas,
         Recibos
      },
      data() {
         return {
            modulo: 'facturas',
         };
      },
      methods: {
         cerrar() {
            this.$emit('salir')
         },
         set_modulo(modulo) {
            this.modulo = modulo
         }
      },
   };
</script>

<style></style>